import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the casino report view.
 * @extends JetView
 */
export default class tableCasinoReportView extends JetView {
    /**
     * Configures the layout of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        var vthis = this; // Reference to the current instance
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function

        /**
         * Formats a percentage value.
         * @param {number} value - The value to format.
         * @returns {string} The formatted percentage string.
         */
        function percentFormat(value) {
            return webix.i18n.numberFormat(value) + '%'; // Formatting value as percentage
        }

        // Extending the summTreeColumn filter to calculate sums for tree columns
        webix.ui.datafilter.summTreeColumn = webix.extend(
            {
                refresh: function (master, node, value) {
                    var result = 0; // Variable to hold the sum result
                    var resultFormat = 0; // Variable for formatted result
                    master.data.each(function (obj) {
                        if (obj.$level == 1) {
                            // Check if the object is at level 1
                            result += obj[value.columnId]; // Accumulate the sum
                        }
                    });
                    // Formatting the result based on the column type
                    if (value.columnId === 'CantidadTickets') {
                        resultFormat = webix.i18n.intFormat(result);
                    } else {
                        if (value.columnId === 'Profitness') {
                            resultFormat = webix.i18n.numberFormat(result) + '%';
                        } else {
                            resultFormat = webix.i18n.priceFormat(result);
                        }
                    }
                    node.firstChild.innerHTML = resultFormat; // Update the node with the formatted result
                },
            },
            webix.ui.datafilter.summColumn, // Inherit from summColumn filter
        );

        return {
            rows: [
                {
                    cols: [
                        {
                            type: 'wide',
                            view: 'datatable', // Data table view
                            id: 'datatable', // Unique identifier for the datatable
                            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                            select: true, // Enable row selection
                            height: 0, // Initial height
                            columns: [
                                // Column definitions for the datatable
                                {
                                    id: 'detailTittle',
                                    header: '',
                                    width: 50,
                                    height: 25,
                                    tooltip: _('Detalles'), // Tooltip for the column
                                    template: function (obj) {
                                        return "<span class='webix_icon wxi-close details'></span>"; // Template for detail icon
                                    },
                                },
                                {
                                    id: 'Id',
                                    header: 'Id',
                                    width: 100,
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Date',
                                    header: _('Fecha'), // Localized header
                                    width: 150,
                                    sort: 'int',
                                },
                                {
                                    id: 'Username',
                                    header: _('Usuario'), // Localized header
                                    width: 100,
                                    sort: 'int',
                                    template: function (obj) {
                                        return (
                                            "<span class='webix_icon wxi-close user'></span> " + obj.Username // Template for user icon and username
                                        );
                                    },
                                },
                                {
                                    id: 'Game',
                                    header: _('Juego'), // Localized header
                                    width: 200,
                                    sort: 'int',
                                },
                                {
                                    id: 'Identifier',
                                    header: _('Identificador'), // Localized header
                                    width: 100,
                                    sort: 'int',
                                },
                                {
                                    id: 'Type',
                                    header: '',
                                    width: 40,
                                    sort: 'int',
                                    template: function (obj) {
                                        if (obj.Type == 'FS') {
                                            return "<span class='webix_icon wxi-close icon-gift'></span>"; // Template for FS type
                                        } else {
                                            return "<span class='webix_icon wxi-close icon-ticket1'></span>"; // Template for other types
                                        }
                                    },
                                },
                                {
                                    id: 'ProviderName',
                                    header: _('Proveedor'), // Localized header
                                    width: 100,
                                    sort: 'int',
                                },
                                {
                                    id: 'Bets',
                                    header: _('Cantidad'), // Localized header
                                    width: 100,
                                    sort: 'int',
                                },
                                {
                                    id: 'Stakes',
                                    header: _('Apuestas'), // Localized header
                                    format: webix.i18n.priceFormat, // Formatting function
                                    exportType: 'number', // Export type
                                    width: 200,
                                    sort: 'int',
                                },
                                {
                                    id: 'TaxBet',
                                    header: _('Impuesto Apuesta'), // Localized header
                                    format: webix.i18n.priceFormat,
                                    exportType: 'number',
                                    width: 200,
                                    sort: 'int',
                                },
                                {
                                    id: 'Tax',
                                    header: _('Impuesto Premios'), // Localized header
                                    format: webix.i18n.priceFormat,
                                    exportType: 'number',
                                    width: 200,
                                    sort: 'int',
                                },
                                {
                                    id: 'FreeBalance',
                                    header: _('Saldo Gratis'), // Localized header
                                    width: 200,
                                    sort: 'int',
                                    format: webix.i18n.priceFormat,
                                    exportType: 'number',
                                },
                                {
                                    id: 'Winnings',
                                    header: _('Premios'), // Localized header
                                    format: webix.i18n.priceFormat,
                                    exportType: 'number',
                                    width: 200,
                                    sort: 'int',
                                },
                                {
                                    id: 'Profit',
                                    header: 'GGR ', // Header for GGR
                                    format: webix.i18n.priceFormat,
                                    exportType: 'number',
                                    width: 150,
                                    sort: 'int',
                                },
                                {
                                    id: 'WinningsBonus',
                                    header: _('Premios Bonos'), // Localized header
                                    width: 200,
                                    sort: 'int',
                                    format: webix.i18n.priceFormat,
                                    exportType: 'number',
                                },
                                {
                                    id: 'OtherBonus',
                                    header: _('Otros Bonos'), // Localized header
                                    width: 200,
                                    sort: 'int',
                                    format: webix.i18n.priceFormat,
                                    exportType: 'number',
                                },
                                {
                                    id: 'Profitness',
                                    header: _('% GGR'), // Localized header
                                    format: percentFormat, // Custom formatting function
                                    width: 200,
                                    sort: 'int',
                                },
                            ],
                            on: {
                                onBeforeLoad: function () {
                                    this.showOverlay(
                                        // Show loading overlay
                                        "<div id='contenedor'; class='container-preload'><div style='position: fixed; top: calc(50% - 57px);left: calc(50% - 60px);width: 120px;' class='progress'><div class='icon-preload girando'></div><div class='load-text'>Loading... </div></div></div>",
                                    );
                                },
                                onAfterLoad: function () {
                                    this.hideOverlay(); // Hide loading overlay after data is loaded
                                },
                            },
                            onClick: {
                                details: function (euv, id) {
                                    var item = this.getItem(id); // Get the clicked item
                                    this.$scope.app.callEvent('user:id', [
                                        item.Id, // Trigger event with user ID
                                    ]);
                                    if (screen.width < 500 || screen.height < 500) {
                                        $$('windowDetailsCasino').show(); // Show details in a window for small screens
                                    } else {
                                        $$('dColl').expand(); // Expand details for larger screens
                                        $$('formDetails').clear(); // Clear the details form
                                        $$('a5').scrollTo(
                                            0,
                                            $$('formDetails').$height + $$('datatable').$height / 2 + 55,
                                        ); // Scroll to the details form
                                    }
                                },
                                user: function (euv, id) {
                                    var item = this.getItem(id); // Get the clicked item
                                    this.$scope.app.callEvent(
                                        'popupUserIframe',
                                        [item.Username], // Trigger event to show user info
                                    );
                                },
                            },
                            ready: function () {
                                if (!this.count()) {
                                    // Check if there are no data items
                                    webix.extend(this, webix.OverlayBox); // Extend with overlay functionality
                                    this.showOverlay(
                                        "<div class='no-data' style='margin:75px; font-size:18px;'>" +
                                            _('No hay datos') + // Show no data message
                                            '</div>',
                                    );
                                }
                            },
                            tooltip: true, // Enable tooltips
                            math: true, // Enable mathematical operations
                            loadahead: 0, // Load ahead configuration
                            datafetch: devConfig.getDefaultDataFetch(), // Fetch configuration
                            pager: 'pagerA', // Pager ID
                        },
                        {
                            type: 'wide',
                            scrollY: true, // Enable vertical scrolling
                            height: 0, // Initial height
                            view: 'treetable', // Tree table view
                            id: 'datatable2', // Unique identifier for the second datatable
                            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                            columns: [
                                // Column definitions for the tree table
                                {
                                    id: 'ProviderName',
                                    header: _('Proveedor'), // Localized header
                                    fillspace: 0,
                                    minWidth: 0,
                                    width: 200,
                                    sort: 'text', // Sorting type
                                    format: dateFormat, // Formatting function
                                    template: function (obj, common) {
                                        if (obj.$group)
                                            return (
                                                common.treetable(obj, common) + obj.value // Template for grouped items
                                            );
                                        return obj.ProviderName; // Return provider name for non-grouped items
                                    },
                                },
                                {
                                    id: 'Game',
                                    header: _('Juego'), // Localized header
                                    width: 150,
                                    sort: 'int',
                                },
                                {
                                    id: 'Bets',
                                    header: _('Cantidad'), // Localized header
                                    width: 100,
                                    sort: 'int',
                                },
                                {
                                    id: 'Stakes',
                                    header: _('Apuestas'), // Localized header
                                    width: 200,
                                    sort: 'int',
                                    format: webix.Number.numToStr({
                                        groupDelimiter: ',',
                                        groupSize: 3,
                                        decimalDelimiter: '.',
                                        decimalSize: 2,
                                    }), // Custom number formatting
                                    exportType: 'number', // Export type
                                },
                                {
                                    id: 'TaxBet',
                                    header: _('Impuesto Apuesta'), // Localized header
                                    width: 200,
                                    sort: 'int',
                                    format: webix.i18n.priceFormat, // Formatting function
                                    exportType: 'number',
                                },
                                {
                                    id: 'TaxPayout',
                                    header: _('Impuesto Premios'), // Localized header
                                    width: 200,
                                    sort: 'int',
                                    format: webix.i18n.priceFormat,
                                    exportType: 'number',
                                },
                                {
                                    id: 'FreeBalance',
                                    header: _('Saldo Gratis'), // Localized header
                                    width: 200,
                                    sort: 'int',
                                    format: webix.i18n.priceFormat,
                                    exportType: 'number',
                                },
                                {
                                    id: 'Winnings',
                                    header: _('Premios'), // Localized header
                                    width: 200,
                                    sort: 'int',
                                    format: webix.i18n.priceFormat,
                                    exportType: 'number',
                                },
                                {
                                    id: 'WinningsBonus',
                                    header: _('Premios Bonos'), // Localized header
                                    width: 200,
                                    sort: 'int',
                                    format: webix.i18n.priceFormat,
                                    exportType: 'number',
                                },
                                {
                                    id: 'Bonus',
                                    header: _('Bonos'), // Localized header
                                    width: 150,
                                    sort: 'int',
                                    format: webix.i18n.priceFormat,
                                    exportType: 'number',
                                },
                                {
                                    id: 'Profit',
                                    header: _('GGR'), // Localized header
                                    width: 150,
                                    sort: 'int',
                                    format: webix.i18n.priceFormat,
                                    exportType: 'number',
                                },
                                {
                                    id: 'Profitness',
                                    header: _('% GGR'), // Localized header
                                    format: percentFormat, // Custom formatting function
                                    width: 150,
                                    sort: 'int',
                                },
                            ],
                            on: {
                                onBeforeLoad: function () {
                                    this.showOverlay(
                                        // Show loading overlay
                                        "<div id='contenedor'; class='container-preload'><div style='position: fixed; top: calc(50% - 57px);left: calc(50% - 60px);width: 120px;' class='progress'><div class='icon-preload girando'></div><div class='load-text'>Loading... </div></div></div>",
                                    );
                                },
                                onAfterLoad: function () {
                                    this.hideOverlay(); // Hide loading overlay after data is loaded
                                },
                            },
                            ready: function () {
                                if (!this.count()) {
                                    // Check if there are no data items
                                    webix.extend(this, webix.OverlayBox); // Extend with overlay functionality
                                    this.showOverlay(
                                        "<div class='no-data' style='margin:75px; font-size:18px;'>" +
                                            _('No hay datos') + // Show no data message
                                            '</div>',
                                    );
                                }
                            },
                            tooltip: true, // Enable tooltips
                            math: true, // Enable mathematical operations
                            loadahead: devConfig.getDefaultDataFetch(), // Fetch configuration
                            pager: {
                                size: 10000, // Page size
                                id: 'pagerr', // Pager ID
                            },
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event handlers.
     * @param {Object} grid - The main data grid.
     */
    init(grid) {
        const _ = this.app.getService('locale')._; // Localization service
        grid = $$('datatable'); // Reference to the main datatable
        var grid2 = $$('datatable2'); // Reference to the second datatable
        var datata = $$('datata'); // Reference to another data element
        var url = devConfig.geturlApi() + 'null/Report/GetCasinoGamesReport'; // API endpoint for casino games report
        var url2 = devConfig.geturlApi() + 'null/Report/GetCasinoGamesReport'; // Duplicate API endpoint for second datatable
        var flag = false; // Flag for export operations
        var vthis = this; // Reference to the current instance
        grid.hide(); // Hide the main grid initially
        $$('toolbar1').hide(); // Hide the first toolbar
        grid2.attachEvent('onAfterLoad', function () {
            $$('datatable2').data.group({
                // Grouping data in the second datatable
                by: function (obj) {
                    return obj.ProviderName + '-' + obj.CurrencyId; // Group by provider name and currency ID
                },
                map: {
                    ProviderName: ['ProviderName'],
                    CurrencyId: ['CurrencyId'],
                    CountryIcon: ['CountryIcon'],
                    Profit: ['Profit', 'sum'], // Sum profit
                    Bets: ['Bets', 'sum'], // Sum bets
                    Stakes: ['Stakes', 'sum'], // Sum stakes
                    FreeBalance: ['FreeBalance', 'sum'], // Sum free balance
                    Winnings: ['Winnings', 'sum'], // Sum winnings
                    WinningsBonus: ['WinningsBonus', 'sum'], // Sum winnings bonus
                    Bonus: ['Bonus', 'sum'], // Sum bonuses
                    Profitness: [
                        'Profitness',
                        function (prop, data) {
                            console.log('data:: ', data); // Log data for debugging
                            if (!data.length) return 0; // Return 0 if no data
                            var summ1 = 0; // Variable for stakes and free balance sum
                            var summ2 = 0; // Variable for profit sum
                            for (var i = data.length - 1; i >= 0; i--) {
                                summ1 = summ1 + Math.floor(data[i].Stakes); // Accumulate stakes
                                if (Math.floor(data[i].FreeBalance) > 0) {
                                    summ1 = summ1 + Math.floor(data[i].FreeBalance); // Accumulate free balance if greater than 0
                                }
                                summ2 = summ2 + Math.floor(data[i].Profit); // Accumulate profit
                            }
                            return (summ2 / summ1) * 100; // Calculate and return the percentage
                        },
                    ],
                },
            });
            $$('datatable2').data.group({
                // Grouping data by currency ID and country icon
                by: function (obj) {
                    return (
                        "<i class='flags " + obj.CountryIcon + "'></i>" + obj.CurrencyId // Template for grouped items
                    );
                },
                map: {
                    Profit: ['Profit', 'sum'], // Sum profit
                    Bets: ['Bets', 'sum'], // Sum bets
                    Stakes: ['Stakes', 'sum'], // Sum stakes
                    FreeBalance: ['FreeBalance', 'sum'], // Sum free balance
                    Winnings: ['Winnings', 'sum'], // Sum winnings
                    WinningsBonus: ['WinningsBonus', 'sum'], // Sum winnings bonus
                    Bonus: ['Bonus', 'sum'], // Sum bonuses
                    Profitness: [
                        'Profitness',
                        function (prop, data) {
                            console.log('data:: ', data); // Log data for debugging
                            if (!data.length) return 0; // Return 0 if no data
                            var summ1 = 0; // Variable for stakes and free balance sum
                            var summ2 = 0; // Variable for profit sum
                            for (var i = data.length - 1; i >= 0; i--) {
                                summ1 = summ1 + Math.floor(data[i].Stakes); // Accumulate stakes
                                summ1 = summ1 + Math.floor(data[i].FreeBalance); // Accumulate free balance
                                summ2 = summ2 + Math.floor(data[i].Profit); // Accumulate profit
                            }
                            return (summ2 / summ1) * 100; // Calculate and return the percentage
                        },
                    ],
                },
            });
        });
        var filter = ''; // Filter string for API requests
        this.on(this.app, 'casinoReport:filter', (filterData) => {
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Query string for date filters
            var string2 = ''; // Query string for sorting
            var providergroup = 0; // Provider group flag
            for (var i = 0; i < object.length; i++) {
                if (object[i][0] == 'IsDetails') {
                    if (object[i][1] == 0) {
                    } else {
                        providergroup = 1; // Set provider group flag if details are requested
                    }
                }
                if (object[i][0] == 'Sort' && providergroup == 0) {
                    if (object[i][1] == '1') {
                        string2 = string2 + '&sort[Date]='; // Sort by date
                    } else {
                        if (object[i][1] == '2') {
                            string2 = string2 + '&sort[Username]='; // Sort by username
                        } else {
                            if (object[i][1] == '3') {
                                string2 = string2 + '&sort[Stakes]='; // Sort by stakes
                            } else {
                                if (object[i][1] == '4') {
                                    string2 = string2 + '&sort[Winnings]='; // Sort by winnings
                                }
                            }
                        }
                    }
                }
                if (object[i][0] == 'Dir' && providergroup == 0) {
                    if (object[i][1] == '0') {
                        string2 = string2 + 'asc'; // Ascending order
                    } else {
                        if (object[i][1] == '1') {
                            string2 = string2 + 'desc'; // Descending order
                        }
                    }
                }
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    if (object[i][0] == 'Datepicker') {
                        var date = object[i][1].split(' - '); // Split date range
                        console.log(date); // Log date for debugging
                        string1 = string1 + '&dateFrom=' + date[0]; // Add dateFrom to query string
                        string1 = string1 + '&dateTo=' + date[1]; // Add dateTo to query string
                    } else {
                        if (object[i][0] != 'Sort' && object[i][0] != 'Dir' && object[i][0] != 'Date') {
                            string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other filters to query string
                        } else {
                            if (object[i][0] == 'Date') {
                                var date = object[i][1].replace(' 00:00:00', ''); // Clean date string
                                string1 = string1 + '&dateFrom=' + date; // Add dateFrom to query string
                                string1 = string1 + '&dateTo=' + date; // Add dateTo to query string
                            }
                        }
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        var object2 = Object.entries(object[i][1]); // Convert nested object to entries
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    var d = new Date(object2[j][1]); // Create date object from start
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        '-' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        '-' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2); // Format dateFrom
                                    string1 = string1 + '&' + dateFrom; // Add dateFrom to query string
                                } else {
                                    if (object2[j][0] === 'end') {
                                        var d = new Date(object2[j][1]); // Create date object from end
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            '-' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            '-' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2); // Format dateTo
                                        string1 = string1 + '&' + dateTo; // Add dateTo to query string
                                    }
                                }
                            }
                        }
                    }
                }
            }
            if (providergroup == 0) {
                grid.show(); // Show the main grid
                grid2.hide(); // Hide the second grid
                grid.clearAll(); // Clear existing data in the main grid
                grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1 + string2).then(function (data) {
                    data = data.json(); // Parse the response data
                    var columnsGrid = []; // Array to hold column IDs
                    grid.config.columns.forEach((item) => {
                        columnsGrid.push(item.id); // Populate column IDs
                    });
                    var difference = columnsGrid.filter((x) => Object.keys(data.data[0]).indexOf(x) === -1); // Check for missing columns in the response
                    if (difference.length > 0) {
                        difference.forEach((id) => {
                            if (id != 'detailTittle') {
                                grid.hideColumn(id); // Hide missing columns
                            }
                        });
                        grid.refreshColumns(); // Refresh column visibility
                    }
                });
                $$('toolbar1').show(); // Show the first toolbar
                $$('toolbar2').hide(); // Hide the second toolbar
            } else {
                if (screen.width > 500 && screen.height > 500) {
                    $$('dColl').collapse(); // Collapse details for larger screens
                }
                grid2.show(); // Show the second grid
                grid.hide(); // Hide the main grid
                grid2.clearAll(); // Clear existing data in the second grid
                grid2.load(url2 + '?start=0&count=' + grid2.data.$pagesize + string1 + string2).then(function (data) {
                    data = data.json(); // Parse the response data
                    var columnsGrid = []; // Array to hold column IDs
                    grid2.config.columns.forEach((item) => {
                        columnsGrid.push(item.id); // Populate column IDs
                    });
                    var difference = columnsGrid.filter((x) => Object.keys(data.data[0]).indexOf(x) === -1); // Check for missing columns in the response
                    if (difference.length > 0) {
                        difference.forEach((id) => {
                            grid2.hideColumn(id); // Hide missing columns
                        });
                        grid2.refreshColumns(); // Refresh column visibility
                    }
                });
                grid2.adjust(); // Adjust the second grid layout
                $$('toolbar2').show(); // Show the second toolbar
                $$('toolbar1').hide(); // Hide the first toolbar
            }
            filter = string1 + string2; // Update the filter string
            $$('filterPopup').hide(); // Hide the filter popup
        });
        grid.attachEvent('onAfterSort', function (by, dir, as) {
            grid.load(
                url + '?start=0&count=' + grid.data.$pagesize + filter + '&sort[' + by + ']=' + dir, // Load data after sorting
            );
        });
        this.on(this.app, 'player:select', (id) => {
            grid.load(
                grid.data.url + '?start=0&count=' + grid.data.$pagesize + '&PlayerId=' + id, // Load data for selected player
            );
        });
        this.on(this.app, 'export:filter', (filterData) => {
            flag = true; // Set export flag
            var firstfirst;
            if (filterData.first == 0) {
                firstfirst = filterData.first + 1; // Adjust first index for export
            } else {
                firstfirst = filterData.first;
            }
            grid.load(
                url + '?start=' + firstfirst + '&count=' + (filterData.last + 1) + filter, // Load data for export
            );
            grid.attachEvent(
                'onAfterLoad',
                function () {
                    if (flag) {
                        var size = grid.getPager().config.size; // Get page size
                        var page = grid.getPage(); // Get current page
                        var first = size * page; // Calculate first index
                        var last = first + size - 1; // Calculate last index
                        if ($$('Export1').getValue() == '1') {
                            console.log('Entro'); // Log for debugging
                            for (var j = 0; j < grid.config.columns.length; j++) {
                                if (grid.config.columns[j].exportType) {
                                    delete grid.config.columns[j].format; // Remove format for export
                                }
                            }
                            this.app.callEvent('export:data', [
                                {
                                    NameReport:
                                        _('Casino') +
                                        ($$('datatable').count() > 0 ? '' : _(' - No hay datos')) +
                                        ' - ' +
                                        new Date().toLocaleString(),
                                    TypeReport: 'Excel', // Set report type to Excel
                                },
                            ]);
                            webix.toExcel(grid, {
                                filter: function (obj) {
                                    return (
                                        grid.getIndexById(obj.id) >= first && grid.getIndexById(obj.id) <= last // Filter data for export
                                    );
                                },
                                filename:
                                    'Virtualsoft - ' +
                                    new Date()
                                        .toLocaleString('en-GB', {
                                            hour12: true,
                                        })
                                        .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                        .replace(/[\/:]/g, '_')
                                        .toUpperCase() +
                                    ' - ' +
                                    ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                    _('Casino'),
                                ignore: { detailTittle: true, Type: true }, // Ignore specific columns
                                footer: false, // Do not include footer in export
                            });
                        } else {
                            if ($$('Export1').getValue() == '2') {
                                this.app.callEvent('export:data', [
                                    {
                                        NameReport:
                                            _('Casino') +
                                            ($$('datatable').count() > 0 ? '' : _(' - No hay datos')) +
                                            ' - ' +
                                            new Date().toLocaleString(),
                                        TypeReport: 'PDF', // Set report type to PDF
                                    },
                                ]);
                                webix.toPDF(grid, {
                                    filter: function (obj) {
                                        return (
                                            grid.getIndexById(obj.id) >= first && grid.getIndexById(obj.id) <= last // Filter data for export
                                        );
                                    },
                                    filename:
                                        'Virtualsoft - ' +
                                        new Date()
                                            .toLocaleString('en-GB', {
                                                hour12: true,
                                            })
                                            .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                            .replace(/[\/:]/g, '_')
                                            .toUpperCase() +
                                        ' - ' +
                                        ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                        _('Casino'),
                                    autowidth: true, // Enable auto width for PDF
                                    ignore: { detailTittle: true, Type: true }, // Ignore specific columns
                                    footer: false, // Do not include footer in export
                                });
                            }
                        }
                        flag = false; // Reset export flag
                        $$('Export1').setValue(''); // Reset export selection
                    }
                }.bind(this),
            );
        });
        this.on(this.app, 'popupUserIframe', (id) => {
            webix
                .ui({
                    view: 'window', // Create a new window for user information
                    id: 'popupUserIframe',
                    head: {
                        view: 'toolbar',
                        cols: [
                            {
                                view: 'label',
                                label: _('Información'), // Header label
                                align: 'center',
                            },
                            {
                                view: 'icon',
                                icon: 'wxi-close',
                                click: function () {
                                    this.getTopParentView().hide(); // Close the window
                                },
                            },
                        ],
                    },
                    position: 'center', // Center the window
                    modal: true, // Make the window modal
                    body: {
                        view: 'iframe', // Iframe for displaying user information
                        id: 'frame-body',
                        src: '/#!/top/customers?user=' + id + '/information', // Source URL for the iframe
                    },
                })
                .show(); // Show the window
            $$('popupUserIframe').setPosition(15, 15); // Set position of the window
            $$('popupUserIframe').$setSize($(window).width() - 30, $(window).height() - 30); // Set size of the window
        });
    }
}

// FILE DOCUMENTED
